// extracted by mini-css-extract-plugin
module.exports = {"container":"activities_container__1N-jc","title":"activities_title__3rONn","info":"activities_info__2TIyE","type":"activities_type__2IHul"};